export const removeNullValues = <T>(obj: Record<string, T | null>): Record<string, T> => {
  return Object.entries(obj).reduce(
    (a, [k, v]) => (v == null ? a : { ...a, [k]: v }),
    {} as Record<string, T>
  )
}
